var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import classNames from "classnames";
import React from "react";
import { Banner } from "./Banner";
import { MediaQuery } from "../responsive/MediaQuery";
import { blurredBannerCls, blurredBannerBlurredCls, blurredBannerBlurredTabletCls, blurredBannerClearedCls, blurredBannerClearedWrapperCls, screenMd, screenXl } from "./Blurred.less";
var BlurredBanner = /* @__PURE__ */ __name(function BlurredBanner2(_ref) {
  var children = _ref.children, _ref$content = _ref.content, content = _ref$content === void 0 ? null : _ref$content, _ref$showForTablet = _ref.showForTablet, showForTablet = _ref$showForTablet === void 0 ? false : _ref$showForTablet;
  return /* @__PURE__ */ React.createElement("div", {
    className: blurredBannerCls
  }, /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: screenMd
  }, function(isTablet) {
    return /* @__PURE__ */ React.createElement(MediaQuery, {
      minWidth: screenXl
    }, function(isDesktop) {
      return isDesktop || isTablet && showForTablet ? /* @__PURE__ */ React.createElement(Banner, {
        className: classNames(blurredBannerBlurredCls, showForTablet && blurredBannerBlurredTabletCls),
        size: "medium",
        media: children
      }) : null;
    });
  }), /* @__PURE__ */ React.createElement("div", {
    className: blurredBannerClearedWrapperCls
  }, content ? /* @__PURE__ */ React.createElement("div", {
    className: blurredBannerClearedCls
  }, content) : /* @__PURE__ */ React.createElement(Banner, {
    className: blurredBannerClearedCls,
    size: "medium",
    media: children
  })));
}, "BlurredBanner");
export {
  BlurredBanner
};
